const store = {
  initStore: () => {}
}

export default store
